<div  class="pivot-radio-wrapper" (click)="handleClick($event)" [ngClass]="styleClass" [ngStyle]="style">
    <div class="pivot-outer-circle" [ngClass]="{'button-container-checked': isChecked, 'radio-disable' : disabled }"></div>
    <div class="pivot-inner-circle" *ngIf="isChecked"></div>
</div>